import request from './request';
import { getEnv } from '../environment';

export const getStatesByCountryId = async (countryId: string) => {
  return await request({
    path: `${getEnv().REACT_APP_LOCALIZATION_URL}/states/by-country-id/${countryId}`,
  });
};
